

let backendHost;
let socketHost;

const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const hostname = window && window.location && window.location.hostname;
 if(hostname === 'qbackft.cianlogic.com') {
  backendHost = 'https://qftapi.cianlogic.com';
  socketHost = 'wss://qftapi.cianlogic.com';
}else if(hostname === 'localhost') {
  
  backendHost = 'https://qftapi.cianlogic.com';
  socketHost = 'wss://qftapi.cianlogic.com';

}else if(hostname === 'qbackftstage.cianlogic.com') {
  backendHost = 'https://qftstageapi.cianlogic.com';
  socketHost = 'wss://qftstageapi.cianlogic.com';
}
else if(hostname === 'qftsupport.felixacare.com') {
  backendHost = 'https://qftapi.felixacare.com';
  socketHost = 'wss://qftapi.felixacare.com';
}


export const APIURL = `${backendHost}`;
export const SOCKETURL = `${socketHost}`;
export const TZ = `timeZone=${currentTimezone}`;




